// Words for the records-only practice role (MEET R1/R2/R3), both verticals.
// House voice: plain, second person, no rule codes.

export const ACCESS_CHOICE = {
  full: {
    label: 'Full access',
    detail: 'Sees results and reports',
  },
  records: {
    label: 'Records only',
    detail: 'Sends records and answers questions, never sees results',
  },
} as const;

export const ACCESS_CHOICE_LEGEND = 'What they can see';

/** "Full access: sees results and reports" — one line, for a select option. */
export function accessChoiceLine(kind: 'full' | 'records'): string {
  const choice = ACCESS_CHOICE[kind];
  return `${choice.label}: ${choice.detail.charAt(0).toLowerCase()}${choice.detail.slice(1)}`;
}

export const ACCESS_ROW_LABEL = {
  admin: 'Admin · full access',
  full: 'Full access',
  records: 'Records only',
} as const;

export const ACCESS_CHANGE_ACTION = 'Change access';
export const ACCESS_CHANGE_SAVE = 'Save access';
export const ACCESS_CHANGE_CANCEL = 'Cancel';
export const ACCESS_CHANGED_TOAST = (email: string, kind: 'full' | 'records') =>
  kind === 'full'
    ? `${email} now has full access.`
    : `${email} now has records-only access.`;

export const ACCESS_DEFAULT_NOTE =
  'New people start with records only. Choose full access for someone who should see results and reports.';

/** The capacity name in "View as". */
export const RECORDS_CAPACITY_LABEL = 'The practice (records only)';

/** The quiet note at the top of a records-only person's home. */
export const RECORDS_HOME_NOTE = {
  title: 'You send records and answer questions for this practice.',
  body: "Results and reports go to the people the practice's owners chose. Start with the first item below.",
} as const;

export const ACCESS_SECTION_LEAD =
  'People listed here can open this practice. Records-only people send records and answer questions; they never see results. Admins can also invite and remove people. VerityRx manages access for counsel and its team.';

export const ACCESS_ADMIN_NOTE = '— can also invite and remove people. Always full access.';

/** The access a removal names: "Remove full access for …". */
export const ACCESS_REMOVE_WORD = {
  admin: 'admin',
  full: 'full',
  records: 'records-only',
} as const;
